<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - {{getTitle}} setting: {{ setting.key }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Key</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field id="modify_setting_key_field"
                                              v-model="setting.key"
                                              name="key"
                                              color="grey darken-2"
                                              :disabled="disabled"
                                              class="text-xs-left"
                                              v-validate="'required:true'"
                                              :error-messages="errors.first('key')"
                                ></v-text-field>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Value</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field id="modify_setting_value_field"
                                              v-model="setting.value"
                                              name="value"
                                              color="grey darken-2"
                                              :disabled="disabled"
                                              class="text-xs-left"
                                              v-validate="'required:true'"
                                              :error-messages="errors.first('value')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Description</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_setting_description_field"
                                        v-model="setting.description"
                                        name="description"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="modify_setting_save_button" class="text-none" color="green" small dark
                               @click="onSaveSetting"
                               :disabled="disabled">
                            Save
                        </v-btn>
                        <v-btn id="modify_setting_cancel_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import settinginterface from "../../../interfaces/settinginterface";
    import {EventBus} from "../../../eventbus";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'ShowSettingModal',

        data: () => ({
            error: false,
            errorMessage: null
        }),

        props: {
            value: Boolean,

            editMode: Boolean,
            disabled: Boolean,

            setting: {
                settingId: Number,
                key: String,
                value: String,
                description: String
            }
        },

        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "Create";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSaveSetting() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (!this.editMode) {
                            await settinginterface.postSetting(this.setting, res => {
                                response = res;
                            });
                        } else {
                            await settinginterface.putSetting(this.setting, res => {
                                response = res;
                            });
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await EventBus.$emit('refreshSettingList');
                            await this.close();
                        }
                    }
                });
            },

            async close() {
                await EventBus.$emit('settingModalClosed');

                this.clearData();
                this.clearAlert();

                this.onShow = false;
            },

            clearData() {
                this.setting.settingId = null;
                this.setting.key = null;
                this.setting.value = null;
                this.setting.description = null;

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/settings/modals/ShowSettingModal.vue